import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { defaultGroundingConfiguration } from '../../../../../cross-team-shared/state/layer-settings-state-3d';
import { settingsStoreToken } from '../../../../../cross-team-shared/state/setting-state';
import { EventTrackingService } from '../../../../../shared/event-tracking/event-tracking.service';

@Component({
  selector: 'h3-grounding-settings',
  templateUrl: './grounding-settings.component.html',
  styleUrl: './grounding-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GroundingSettingsComponent {
  groundingConfigurationStore = inject(settingsStoreToken)('layerSettings3d')(
    'groundingConfiguration',
  );

  defaultGroundingConfiguration = defaultGroundingConfiguration;
  searchRadiusConfig = {
    min: 0.1,
    max: 5,
    step: 0.1,
  };

  private eventTracker = inject(EventTrackingService);

  toggleUseAllPoints(event: MatButtonToggleChange) {
    this.groundingConfigurationStore('useAllPoints').set(event.value);

    this.eventTracker.track({
      id: 'change_grounding_settings_use_all_points',
      bucket: 'annotation',
      new_value: this.groundingConfigurationStore.state().useAllPoints,
      source: 'button',
    });
  }
}
